import {
  GET_OFFICE,
  CREATE_OFFICE,
  UPDATE_OFFICE,
  DELETE_OFFICE,
} from "@actions/inventory/roomConfiguration/types";

import {
  OfficeState,
  OfficeStateAction,
} from "@reducers/types/inventory/office-state";

export const initialState: OfficeState = {
  isGetLoading: false,
  isUpdateLoading: false,
  isDeleteLoading: false,
  isCreateLoading: false,

  getError: null,
  createError: null,
  updateError: null,
  deleteError: null,

  getSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,

  getData: null,
};

const officeReducer = (
  state: OfficeState = initialState,
  action: OfficeStateAction,
): OfficeState => {
  const { type, payload } = action;

  switch (type) {
    // fetch
    case GET_OFFICE.LOADING:
      return {
        ...state,...initialState,
        isGetLoading: payload,
        createSuccess: false,
        deleteSuccess: false,
      };

    case GET_OFFICE.SUCCESS:
      return {
        ...state,...initialState,
        getError: null,
        getData: payload,
        isGetLoading: false,
      };

    case GET_OFFICE.ERROR:
      return {
        ...state,...initialState,
        getError: payload,
        getData: null,
        isGetLoading: false,
      };

    // create
    case CREATE_OFFICE.LOADING:
      return {
        ...state,...initialState,
        isCreateLoading: payload,
        createSuccess: false,
      };

    case CREATE_OFFICE.SUCCESS:
      return {
        ...state,...initialState,
        createError: null,
        isCreateLoading: false,
        createSuccess: true,
      };

    case CREATE_OFFICE.ERROR:
      return {
        ...state,...initialState,
        createError: payload,
        isCreateLoading: false,
      };

    // update
    // case UPDATE_OFFICE_LOCATION.LOADING:
    //   return {
    //     ...state,...initialState,
    //     isUpdateLoading: payload,
    //   };

    // case UPDATE_OFFICE_LOCATION.SUCCESS:
    //   const newState = state.getData.data;

    //   const index = newState.findIndex(
    //     (item: OfficeLocation) => item.id === payload.id,
    //   );

    //   if (index >= 0) {
    //     newState[index] = payload;
    //   }

    //   return {
    //     ...state,...initialState,
    //     updateError: null,
    //     getData: {
    //       ...state.getData,
    //       data: newState,
    //     },
    //     isUpdateLoading: false,
    //   };

    // case UPDATE_OFFICE_LOCATION.ERROR:
    //   return {
    //     ...state,...initialState,
    //     updateError: payload,
    //     getData: state.getData,
    //     isUpdateLoading: false,
    //   };

    // delete
    case DELETE_OFFICE.LOADING:
      return {
        ...state,...initialState,
        isDeleteLoading: payload,
        deleteSuccess: false,
      };

    case DELETE_OFFICE.SUCCESS:
      return {
        ...state,...initialState,
        deleteError: null,
        isDeleteLoading: false,
        deleteSuccess: true,
      };

    case DELETE_OFFICE.ERROR:
      return {
        ...state,...initialState,
        deleteError: payload,
        isDeleteLoading: false,
      };

    default:
      return state;
  }
};

export default officeReducer;
